module.exports = __webpack_public_path__ + "static/media/podcast-img.6ab4674d.png";